var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "root", staticClass: "sip-theme-picker" }, [
    _c(
      "button",
      {
        staticClass: "sip-icon-btn sip-header-btn--palette",
        class: { "is-open": _vm.open },
        attrs: {
          type: "button",
          title: "Colour and fonts",
          "aria-label": "Colour and fonts",
          "aria-expanded": _vm.open ? "true" : "false",
        },
        on: {
          click: function ($event) {
            $event.preventDefault()
            return _vm.toggle.apply(null, arguments)
          },
        },
      },
      [_c("admin-icon", { attrs: { name: "palette", size: 18 } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.open,
            expression: "open",
          },
        ],
        staticClass: "sip-theme-panel",
        attrs: { role: "dialog", "aria-label": "Theme and fonts" },
      },
      [
        _c(
          "div",
          { staticClass: "sip-theme-tabs", attrs: { role: "tablist" } },
          [
            _c(
              "button",
              {
                staticClass: "sip-theme-tab",
                class: { "is-active": _vm.tab === "colour" },
                attrs: {
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.tab === "colour" ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    _vm.tab = "colour"
                  },
                },
              },
              [_vm._v("Colour")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "sip-theme-tab",
                class: { "is-active": _vm.tab === "fonts" },
                attrs: {
                  type: "button",
                  role: "tab",
                  "aria-selected": _vm.tab === "fonts" ? "true" : "false",
                },
                on: { click: _vm.openFonts },
              },
              [_vm._v("Fonts")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "colour",
                expression: "tab === 'colour'",
              },
            ],
            staticClass: "sip-theme-pane",
            attrs: { role: "tabpanel" },
          },
          [
            _c("p", { staticClass: "sip-theme-hint" }, [
              _vm._v(
                "Light mode keeps a white sidebar and a neutral page. Theme colour is saved for the school and used on login, primary buttons, and the active menu item."
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sip-theme-swatches",
                attrs: { role: "radiogroup", "aria-label": "Colour palettes" },
              },
              [
                _vm._l(_vm.themes, function (theme) {
                  return _c(
                    "button",
                    {
                      key: theme.id,
                      staticClass: "sip-theme-swatch",
                      class: { "is-active": _vm.themeId === theme.id },
                      attrs: {
                        type: "button",
                        role: "radio",
                        "aria-checked":
                          _vm.themeId === theme.id ? "true" : "false",
                        title: theme.blurb,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectTheme(theme.id)
                        },
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "sip-theme-swatch__dots",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("i", { style: { background: theme.swatches[0] } }),
                          _vm._v(" "),
                          _c("i", { style: { background: theme.swatches[1] } }),
                          _vm._v(" "),
                          _c("i", { style: { background: theme.swatches[2] } }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "sip-theme-swatch__name" }, [
                        _vm._v(_vm._s(theme.name)),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sip-theme-swatch sip-theme-swatch--custom",
                    class: { "is-active": _vm.themeId === "custom" },
                    attrs: {
                      type: "button",
                      role: "radio",
                      "aria-checked":
                        _vm.themeId === "custom" ? "true" : "false",
                      title: "Pick your own accent colour",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectTheme("custom")
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "sip-theme-swatch__dots",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c("i", { style: { background: _vm.custom.sidebar } }),
                        _vm._v(" "),
                        _c("i", { style: { background: _vm.custom.accent } }),
                        _vm._v(" "),
                        _c("i", {
                          staticStyle: {
                            background:
                              "conic-gradient(#0f7a62, #206bc4, #8b2942, #c9a227, #0f7a62)",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "sip-theme-swatch__name" }, [
                      _vm._v("Custom"),
                    ]),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm.themeId === "custom"
              ? _c("div", { staticClass: "sip-theme-custom" }, [
                  _c("label", { staticClass: "sip-theme-color" }, [
                    _c("span", [_vm._v("Accent colour")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sip-theme-color__row" }, [
                      _c("input", {
                        attrs: { type: "color" },
                        domProps: { value: _vm.custom.accent },
                        on: {
                          input: function ($event) {
                            return _vm.onCustom("accent", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "text", maxlength: "7" },
                        domProps: { value: _vm.custom.accent },
                        on: {
                          change: function ($event) {
                            return _vm.onCustomHex(
                              "accent",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "sip-theme-color" }, [
                    _c("span", [_vm._v("Sidebar (optional)")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "sip-theme-color__row" }, [
                      _c("input", {
                        attrs: { type: "color" },
                        domProps: { value: _vm.custom.sidebar },
                        on: {
                          input: function ($event) {
                            return _vm.onCustom("sidebar", $event.target.value)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "text", maxlength: "7" },
                        domProps: { value: _vm.custom.sidebar },
                        on: {
                          change: function ($event) {
                            return _vm.onCustomHex(
                              "sidebar",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "fonts",
                expression: "tab === 'fonts'",
              },
            ],
            staticClass: "sip-theme-pane sip-theme-pane--fonts",
            attrs: { role: "tabpanel" },
          },
          _vm._l(_vm.fonts, function (font) {
            return _c(
              "button",
              {
                key: font.id,
                staticClass: "sip-font-card",
                class: { "is-active": _vm.fontId === font.id },
                style: { fontFamily: font.stack },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.selectFont(font.id)
                  },
                  mouseenter: function ($event) {
                    return _vm.prefetchFont(font)
                  },
                },
              },
              [
                _c("span", { staticClass: "sip-font-card__name" }, [
                  _vm._v(_vm._s(font.name)),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sip-font-card__preview" }, [
                  _vm._v(_vm._s(font.preview)),
                ]),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }